/* ============================================================
   section-faq-accordion.js
   Accordion toggle for .faq__list sections.
   - One item open at a time (closes others in same list)
   - First item rendered open by the server; JS keeps it in sync
   ============================================================ */

(function () {
  'use strict';

  function initFaqList(list) {
    var triggers = list.querySelectorAll('.faq__trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen   = trigger.getAttribute('aria-expanded') === 'true';
        var answerId = trigger.getAttribute('aria-controls');
        var answer   = document.getElementById(answerId);
        var item     = trigger.closest('.faq__item');

        if (isOpen) {
          /* Close this item */
          trigger.setAttribute('aria-expanded', 'false');
          if (answer) answer.setAttribute('hidden', '');
          if (item)   item.classList.remove('faq__item--open');
        } else {
          /* Close all other items in this list */
          triggers.forEach(function (other) {
            if (other === trigger) return;
            var otherAnswer = document.getElementById(other.getAttribute('aria-controls'));
            var otherItem   = other.closest('.faq__item');
            other.setAttribute('aria-expanded', 'false');
            if (otherAnswer) otherAnswer.setAttribute('hidden', '');
            if (otherItem)   otherItem.classList.remove('faq__item--open');
          });

          /* Open this item */
          trigger.setAttribute('aria-expanded', 'true');
          if (answer) answer.removeAttribute('hidden');
          if (item)   item.classList.add('faq__item--open');
        }
      });
    });
  }

  /* Init all FAQ lists on the page */
  document.querySelectorAll('[data-faq-list]').forEach(initFaqList);
})();
